import { xsmall, small, medium, large, xlarge, maxSmall, fullScreen } from './design-tokens';

export type DEVICES = {
    GteXsmall: string;
    GteSmall: string;
    LteSmall: string;
    GteMedium: string;
    GteLarge: string;
    GteXLarge: string;
    FullScreen: string;
    MinResolution2x: string;
};

export const device: DEVICES = {
    GteXsmall: `only screen and (min-width: ${xsmall})`,
    GteSmall: `only screen and (min-width: ${small})`,
    LteSmall: `only screen and (max-width: ${maxSmall})`,
    GteMedium: `only screen and (min-width: ${medium})`,
    GteLarge: `only screen and (min-width: ${large})`,
    GteXLarge: `only screen and (min-width: ${xlarge})`,
    FullScreen: `only screen and (min-width: ${fullScreen})`,
    MinResolution2x:
        'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 192dpi)',
};

export const deviceGte = (screenSize: number): string => `only screen and (min-width: ${screenSize}px)`;
